export enum ModuleOnboardingActions {
  CONNECTWIFI = 1,
  CONNECTMODULE = 2,
  REQUESTDATA = 3,
  CONFIGURECLUSTER = 4,
  INITENVIRONMENT = 5,
  FINALCHECK = 6
}
